import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';
import { FlamingoClientService } from '@mode/shared/data-access-flamingo';

export const DowngradedSharedDataAccessFlamingoModule = angular
  .module('downgraded-shared-data-access-flamingo', [])
  .service('FlamingoClient', downgradeInjectable(FlamingoClientService)).name;
